import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { upperCase } from 'lodash';
import LinkModal from '@/components/LinkModal.vue';
import VueMarkdown from 'vue-markdown';
const armorPropertiesModule = namespace('armorProperties');
let LootArmorProperties = class LootArmorProperties extends Vue {
    created() {
        this.fetchArmorProperties();
    }
    get propertyData() {
        return this.propertyList && this.propertyList.map((propertyString, index) => {
            const propertyName = upperCase(propertyString.split(' ')[0]);
            const text = (index > 0 ? ', ' : ' ') + propertyString;
            const propertyInfo = this.armorProperties.find(({ name }) => upperCase(name) === propertyName);
            return { ...propertyInfo, text };
        }).filter(({ content }) => content);
    }
};
__decorate([
    Prop(Array)
], LootArmorProperties.prototype, "propertyList", void 0);
__decorate([
    armorPropertiesModule.State
], LootArmorProperties.prototype, "armorProperties", void 0);
__decorate([
    armorPropertiesModule.Action
], LootArmorProperties.prototype, "fetchArmorProperties", void 0);
LootArmorProperties = __decorate([
    Component({
        components: {
            LinkModal,
            VueMarkdown
        }
    })
], LootArmorProperties);
export default LootArmorProperties;
